// ----------------------------------------------------------------------
export const setLocal = (key: string, value: any) => {
  return localStorage.setItem(key, value)
}

export const getLocal = (key: string) => {
  const item = localStorage.getItem(key)
  return item
}
export const removeLocal = (key: string) => {
  return localStorage.removeItem(key)
}
export function localStorageAvailable() {
  try {
    const key = '__some_random_key_you_are_not_going_to_use__'
    window.localStorage.setItem(key, key)
    window.localStorage.removeItem(key)
    return true
  } catch (error) {
    return false
  }
}

export function localStorageGetItem(key: string, defaultValue = '') {
  const storageAvailable = localStorageAvailable()

  let value

  if (storageAvailable) {
    value = getLocal(key) || defaultValue
  }

  return value
}
